module.exports = __webpack_public_path__ + "hero.ce3393d1bb80.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/marketing/how-it-works/hero.jpg
// module id = ./src/styles/marketing/how-it-works/hero.jpg
// module chunks = 21